<template>
  <v-container fluid>
    <div id="app">
      <v-app id="inspire">
        <!--Signupg Title-->
        <v-layout row wrap>
          <v-flex xs4 sm4 offset-sm2>
            <UploadFiles
              :parentFileCategory="'HT_AthleteResults'"
              :parentFileType="'.zip,.cl2'"
            />
          </v-flex>
          <v-flex xs4 sm4 offset-sm2>
            <UploadFiles
              :parentFileCategory="'OG_Standards'"
              :parentFileType="'.xlsx'"
            />
          </v-flex>
          <v-flex xs4 sm4 offset-sm2>
            <UploadFiles
              :parentFileCategory="'OG_AthletesResults'"
              :parentFileType="'.xlsx'"
            />
          </v-flex>
          <v-flex xs4 sm4 offset-sm2>
            <UploadFiles
              :parentFileCategory="'OG_AthletesInsUpd'"
              :parentFileType="'.xlsx'"
            />
          </v-flex>
          <v-flex xs4 sm4 offset-sm2>
            <UploadFiles
              :parentFileCategory="'LENEX'"
              :parentFileType="'.lxf,.lef'"
            />
          </v-flex>
          <v-flex xs4 sm4 offset-sm2>
            <UploadFiles :parentFileCategory="'OG'" :parentFileType="'.zip'" />
          </v-flex>
          <v-flex xs4 sm4 offset-sm2>
            <SampleFiles />
          </v-flex>
        </v-layout>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import UploadFiles from "../shared/upload_files.vue";
//import jsonFilesArray from "../../../public/etl/etl_files.json";
import SampleFiles from "../shared/sample_files.vue";

export default {
  components: {
    UploadFiles,
    SampleFiles
  },
  data() {
    return {
      userEmail: ""
    };
  },
  created() {},
  computed: {
    ...mapGetters(["loading", "error"])
    //  localFilesArray.toString = function () { return JSON.stringify(this); }
  },

  watch: {
    //  user(value){
    //
    //  //
    //    // if user value changes б redirect to home page
    //    if(value){
    //      this.$router.push("/landing");
    //    }
    //  }
    //
  },
  mounted() {},

  methods: {}
};
</script>

<style></style>
